export default {
	styleOverrides: {
		root: {
			padding: 16,
		}
	}
};
